/** @jsxImportSource @emotion/react */
import React from "react";
import * as Styles from "./styles";
import { ToolboxSearch } from "./Search";
import { ToolboxColumnToggle } from "./ColumnToggle";
import { ToolboxThumbnailResize } from "./ThumbnailResize";
import { ToolboxEditActions } from "./EditActions";

interface ToolboxProps {
  children: React.ReactNode;
}

const Spacer: React.FC = () => <div css={Styles.pushRightStyle} />;

const ToolboxRoot: React.FC<ToolboxProps> = ({ children }: ToolboxProps) => {
  return <div css={Styles.rowStyle}>{children}</div>;
};

export const Toolbox = Object.assign(ToolboxRoot, {
  Search: ToolboxSearch,
  ColumnToggle: ToolboxColumnToggle,
  ThumbnailResize: ToolboxThumbnailResize,
  EditActions: ToolboxEditActions,
  Spacer,
});
